import React from "react";
import { Activity } from "lucide-react";
import { useTranslation, Trans } from "react-i18next";

const PeerSummaryCard = ({ playerName, position, percentageDiff, insight }) => {
  const { t } = useTranslation();
  const isAbove = percentageDiff > 0;
  const isSignificant = Math.abs(percentageDiff) >= 10;

  // Color scheme based on whether above/below and significance
  const colors = isAbove
    ? {
        bg: isSignificant ? "#FEF3E7" : "#F0FDF4",
        border: isSignificant
          ? "rgba(224, 122, 58, 0.2)"
          : "rgba(16, 185, 129, 0.2)",
        boxBg: isSignificant ? "#E07A3A" : "#10B981",
        text: isSignificant ? "#9A3412" : "#166534",
      }
    : {
        bg: "#F0FDF4",
        border: "rgba(16, 185, 129, 0.2)",
        boxBg: "#10B981",
        text: "#166534",
      };

  const diffLabel = isAbove
    ? t("team.peerSummary.aboveBadge")
    : t("team.peerSummary.belowBadge");

  return (
    <div
      className="flex h-full items-center gap-4 rounded-xl p-4"
      style={{
        backgroundColor: colors.bg,
        border: `1px solid ${colors.border}`,
      }}
    >
      {/* Percentage Box */}
      <div
        className="flex h-[72px] w-[72px] flex-shrink-0 flex-col items-center justify-center rounded-xl"
        style={{ backgroundColor: colors.boxBg }}
      >
        <span className="text-xl font-bold text-white">
          {Math.abs(percentageDiff)}%
        </span>
        <span className="text-[10px] font-medium tracking-wide text-white/90">
          {diffLabel}
        </span>
      </div>

      {/* Content */}
      <div className="min-w-0 flex-1">
        <div className="mb-1.5 flex items-center gap-1.5">
          <Activity size={14} style={{ color: colors.boxBg }} />
          <span className="text-xs font-semibold text-[#111827]">
            {t("team.peerSummary.title")}
          </span>
        </div>
        <p className="text-[13px] leading-snug text-[#374151]">
          <Trans
            i18nKey={
              isAbove
                ? "team.peerSummary.sentenceAbove"
                : "team.peerSummary.sentenceBelow"
            }
            values={{
              name: playerName,
              percent: Math.abs(percentageDiff),
              position: position.toLowerCase(),
            }}
            components={{
              bold: <span className="font-semibold" />,
              diff: (
                <span
                  className="font-semibold"
                  style={{ color: colors.boxBg }}
                />
              ),
            }}
          />
        </p>
        {insight && (
          <p className="mt-1.5 text-[11px] leading-snug text-[#6B7280]">
            {insight}
          </p>
        )}
      </div>
    </div>
  );
};

export default PeerSummaryCard;
